/** Does the session hold a DECISION the close would throw away? Not "has the plan changed": a
 * preview restores, a decision does not. */
import type { StudioDraft } from "../domain/studioTypes";

export interface StudioDirtyInput {
  undoDepth: number;
  /** A fix made on the plan (a card's Auto-fix, Fix vertical blocking, Fix all) and not yet
   *  finalized. It lives outside the draft's history, so the undo depth does not count it. */
  fixesAdopted: boolean;
  draft: Pick<
    StudioDraft,
    | "dismissedFlagIds"
    | "restrictions"
    | "appliedFixFlagIds"
    | "acceptedFlagIds"
    | "sizeTierAnswers"
  >;
}

export const studioIsDirty = (input: StudioDirtyInput): boolean =>
  input.undoDepth > 0 ||
  input.fixesAdopted ||
  input.draft.dismissedFlagIds.length > 0 ||
  input.draft.restrictions.length > 0 ||
  // A size-tag Yes is kept past the close (`keepAnswers`), so closing loses none of them.
  input.draft.appliedFixFlagIds.some((id) => input.draft.sizeTierAnswers?.[id] === undefined) ||
  (input.draft.acceptedFlagIds?.length ?? 0) > 0;
